import type { ReactNode } from "react";

// Line icons in the hand of the order form (order.soulcake.eu) and the order screen (main.soulcake.eu): 24×24,
// 1.7 stroke, round ends. The tools use the same drawings as the soulcake.eu menu.
const paths = {
  box: <><path d="M3.5 8 12 3.5 20.5 8v8L12 20.5 3.5 16z" /><path d="M3.5 8 12 12.5 20.5 8M12 12.5v8" /></>,
  shelves: <><path d="M4 3v18M20 3v18M4 10h16M4 17.5h16" /><path d="M7.5 6h4v4h-4zM13 13h3.5v4.5H13zM7.5 14h3v3.5h-3z" /></>,
  calendarCheck: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M8 3v4M16 3v4M3 10h18M9 15.5l2 2 4-4" /></>,
  // Inventory: a warehouse with its roller door (bars would look like the order screen's Dashboard).
  warehouse: <><path d="M3 20V9l9-5 9 5v11" /><path d="M7 20v-7.5h10V20M7 15.5h10M7 18h10" /></>,
  refresh: <><path d="M20 11a8 8 0 1 0-2.3 6.6" /><path d="M20 4.5V11h-6.5" /></>,
  search: <><circle cx="11" cy="11" r="6.5" /><path d="m20 20-4.4-4.4" /></>,
  close: <path d="M6 6l12 12M18 6 6 18" />,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  external: <><path d="M14 4h6v6M20 4l-9 9" /><path d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" /></>,
  back: <path d="M15 5l-7 7 7 7" />,
  chevronRight: <path d="m9 6 6 6-6 6" />,
} satisfies Record<string, ReactNode>;
export type IconName = keyof typeof paths;

export default function Icon({ name, size = 22, className }: { name: IconName; size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths[name]}
    </svg>
  );
}
